import { Injectable } from '@angular/core';
import { ApiVersion } from '@core/constants';
import { BaseResponse } from '@core/models/base-response';
import { BaseService } from '@core/services/base.service';

import { ResetPasswordTokenModel } from './reset-password-token.model';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordService extends BaseService {
  readonly resetPasswordUrl = 'users/insecure/password/token/by-token/{token}';
  readonly resetPasswordUrl2 =
    'users/insecure/password/usertype/CUSTOMER/token/by-token/{token}';

  sendResetRequest(token: string, password: string, passwordRepeat: string) {
    let url = this.resetPasswordUrl.replace('{token}', token);
    if (password !== passwordRepeat) {
      throw new Error(`passwords are not matched`);
    }

    return this.put<BaseResponse<any>>(
      url,
      {
        password,
        passwordRepeat,
        userType: 'CUSTOMER',
      },
      {
        apiVersion: ApiVersion.V2,
        useRecaptcha: true,
      }
    );
  }

  validateToken(token: string) {
    let url = this.resetPasswordUrl2.replace('{token}', token);
    return this.get<BaseResponse<ResetPasswordTokenModel>>(url, {
      apiVersion: ApiVersion.V1,
      useAuthToken: false,
    });
  }
}
